import { render } from "./Repas.vue?vue&type=template&id=14966c6c"
import script from "./Repas.vue?vue&type=script&lang=js"
export * from "./Repas.vue?vue&type=script&lang=js"

import "./Repas.vue?vue&type=style&index=0&id=14966c6c&lang=less"
script.render = render

export default script